export const XP_CONFIG = {
  BASE_XP_PER_WORKOUT: 50,
  XP_PER_SET: 5,
  XP_PER_MINUTE: 1,
  MAX_DURATION_XP: 30,
  LEVEL_FACTOR: 100,
};
